export enum PurchaseDocumentKind {
    Expense = 'Expense',
    PurchaseInvoice = 'PurchaseInvoice',
    PurchaseInvoiceAdjustment = 'PurchaseInvoiceAdjustment',
    EPurchaseInvoice = 'EPurchaseInvoice'
}
